var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 6C13.25 5.58579 13.5858 5.25 14 5.25L18 5.25C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.41421 18.4142 6.75 18 6.75L14 6.75C13.5858 6.75 13.25 6.41421 13.25 6Z",
    fill: "#15C0B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 10C13.25 9.58579 13.5858 9.25 14 9.25L18 9.25C18.4142 9.25 18.75 9.58579 18.75 10C18.75 10.4142 18.4142 10.75 18 10.75L14 10.75C13.5858 10.75 13.25 10.4142 13.25 10Z",
    fill: "#15C0B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8 6.75C6.77241 6.75 6.75 6.77241 6.75 6.8V9.2C6.75 9.22759 6.77241 9.25 6.8 9.25H9.2C9.22759 9.25 9.25 9.22759 9.25 9.2V6.8C9.25 6.77241 9.22759 6.75 9.2 6.75H6.8ZM5.25 6.8C5.25 5.94399 5.94399 5.25 6.8 5.25H9.2C10.056 5.25 10.75 5.94399 10.75 6.8V9.2C10.75 10.056 10.056 10.75 9.2 10.75H6.8C5.94399 10.75 5.25 10.056 5.25 9.2V6.8Z",
    fill: "#15C0B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 14C13.25 13.5858 13.5858 13.25 14 13.25L18 13.25C18.4142 13.25 18.75 13.5858 18.75 14C18.75 14.4142 18.4142 14.75 18 14.75L14 14.75C13.5858 14.75 13.25 14.4142 13.25 14Z",
    fill: "#15C0B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 18C13.25 17.5858 13.5858 17.25 14 17.25L18 17.25C18.4142 17.25 18.75 17.5858 18.75 18C18.75 18.4142 18.4142 18.75 18 18.75L14 18.75C13.5858 18.75 13.25 18.4142 13.25 18Z",
    fill: "#15C0B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8 14.75C6.77241 14.75 6.75 14.7724 6.75 14.8V17.2C6.75 17.2276 6.77241 17.25 6.8 17.25H9.2C9.22759 17.25 9.25 17.2276 9.25 17.2V14.8C9.25 14.7724 9.22759 14.75 9.2 14.75H6.8ZM5.25 14.8C5.25 13.944 5.94399 13.25 6.8 13.25H9.2C10.056 13.25 10.75 13.944 10.75 14.8V17.2C10.75 18.056 10.056 18.75 9.2 18.75H6.8C5.94399 18.75 5.25 18.056 5.25 17.2V14.8Z",
    fill: "#15C0B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e684b3ed905883d18200ba08e946968f.svg";
export { ForwardRef as ReactComponent };